import React, { Component } from 'react';
import { Button, Modal, Icon } from 'antd';

const navegarAlContingut = (contingut) => {
	const element = document.getElementById(contingut);
	if (element) element.scrollIntoView();
};

const clauIndex = 'index';
const clauSecccioObjecte = 'objecte';
const clauSecccioResponsable = 'responsable';
const clauSecccioFinalitat = 'finalitat';
const clauSecccioRecollida = 'recollida';
const clauSecccioConservacio = 'conservacio';
const clauSecccioComunicacio = 'comunicacio';
const clauSecccioProteccio = 'proteccio';
const clauSecccioDrets = 'drets';
const clauSecccioCookies = 'cookies';
const clauSecccioCanvis = 'canvis';
const clauSecccioContacte = 'contacte';
const clauSecccioReclamacions = 'reclamacions';
const clauSecccioRecomanacions = 'recomanacions';

class AvisLegal extends Component {
	constructor(props) {
		super(props);
		this.state = { modalVisible: false };
		this.mostrarModal = this.mostrarModal.bind(this);
		this.amagarModal = this.amagarModal.bind(this);
	}

	mostrarModal() {
		this.setState({ ...this.state, modalVisible: true });
	}

	amagarModal() {
		this.setState({ ...this.state, modalVisible: false });
	}

	render() {
		const { modalVisible } = this.state;
		const titolModal = (
			<div>
				<Icon type='info-circle' style={{ fontSize: 20, color: '#1890ff' }} /> Avís legal
			</div>
		);
		const botoPujarTaulaContinguts = (
			<a onClick={() => navegarAlContingut(clauIndex)} className='boto-pujar'>
				<Button icon='arrow-up'>Pujar</Button>
			</a>
		);

		return (
			<div>
				<a onClick={this.mostrarModal}> Avís legal</a>
				<Modal
					width='85%'
					wrapClassName='avis-legal-contenidor'
					visible={modalVisible}
					title={titolModal}
					closable={false}
					footer={[
						<Button key='entesos' type='primary' onClick={this.amagarModal}>
							Entesos
						</Button>
					]}
				>
					<div className='avis-legal scrollable'>
						<h3 id={clauIndex}>Taula de continguts</h3>
						<ol>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioObjecte)}>Objecte</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioResponsable)}>Qui és el responsable del tractament de les vostres dades?</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioFinalitat)}>Amb quina finalitat tractem les vostres dades personals i amb quina base legal?</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioRecollida)}>Com recollim les vostres dades personals i quines són?</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioConservacio)}>Durant quant de temps conservarem les vostres dades?</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioComunicacio)}>A qui podem comunicar les vostres dades?</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioProteccio)}>Com protegim les vostres dades?</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioDrets)}>Quins són els vostres drets de protecció de dades i com es poden exercir?</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioCookies)}>
									Galetes (<em>cookies</em>)
								</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioCanvis)}>Canvis en aquesta política</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioContacte)}>Contacte</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioReclamacions)}>Reclamacions</a>
							</li>
							<li>
								<a onClick={() => navegarAlContingut(clauSecccioRecomanacions)}>Recomanacions</a>
							</li>
						</ol>
						<hr />
						<br />
						<br />

						<h4 id={clauSecccioObjecte}>1. Objecte</h4>
						<p>
							D&#39;acord amb el que disposa el Reglament (UE) 2016/679, de 27 d&#39;abril de 2016, relatiu a la protecció de les persones físiques quant al tractament de dades personals (RGPD), aquesta política pretén facilitar-vos la informació prevista als articles 13 i 14 de
							l&#39;esmentat Reglament, així com d&#39;altra que es considera necessària sobre com recollim i com utilitzem les vostres dades personals.
						</p>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioResponsable}>2. Qui és el responsable del tractament de les vostres dades?</h4>
						<p>El responsable del tractament de les vostres dades personals és el Servei Meteorològic de Catalunya (SMC), empresa pública de la Generalitat de Catalunya adscrita al Departament de Territori i Sostenibilitat, amb:</p>
						<ul>
							<li>CIF: Q-0801167-H</li>
							<li>
								Adreça electrònica de contacte: <a href='mailto:protecciodades.meteocat@gencat.cat'>protecciodades.meteocat@gencat.cat</a>
							</li>
							<li>Domicili: carrer Berlín, 38-48, 4ª i 5ª planta, 08029 Barcelona</li>
							<li>Telèfon: 93 567 60 90</li>
						</ul>
						<p>El representant del responsable del tractament és el director del SMC.</p>
						<p>Com a empresa pública, el SMC ha designat un Delegat de Protecció de Dades (DPD). Les seves dades de contacte són:</p>
						<ul>
							<li>
								Adreça electrònica: <a href='mailto:dpd.meteocat@gencat.cat'>dpd.meteocat@gencat.cat</a>
							</li>
							<li>Domicili: carrer Berlín, 38-48, 4ª i 5ª planta, 08029 Barcelona.</li>
						</ul>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioFinalitat}>3. Amb quina finalitat tractem les vostres dades personals i amb quina base legal?</h4>
						<ul>
							<li>
								Per interès legítim:
								<ul>
									<li>Atendre les vostres consultes, peticions, suggeriments, notificacions d&#39;error i queixes.</li>
									<li>Processar les vostres sol·licituds de llocs de treball i els vostres CVs.</li>
									<li>Garantir la vostra seguretat en l&#39;accés a les nostres dependències.</li>
									<li>Dur a terme enquestes de satisfacció i estudis de mercat.</li>
									<li>Millorar els serveis que us oferim.</li>
								</ul>
							</li>
							<li>
								A partir del vostre consentiment:
								<ul>
									<li>Facilitar-vos l&#39;ús personalitzat de les nostres aplicacions web i serveis, sempre que us hagueu registrat amb aquesta finalitat.</li>
									<li>Promocionar i informar-vos de les activitats que duem a terme, productes i altres aspectes relacionats amb els serveis que oferim, mitjançant correus electrònics, el web, les xarxes socials i altres mecanismes.</li>
								</ul>
							</li>
							<li>
								Per relació contractual:
								<ul>
									<li>Gestionar les comandes de productes que feu a través de la botiga electrònica (¿) o del Centre d&#39;Atenció a l&#39;Usuari.</li>
									<li>Gestionar els procediments de contractació administrativa i complir les obligacions derivades dels contractes que hagueu celebrat amb nosaltres.</li>
								</ul>
							</li>
							<li>
								Per motius legals:
								<ul>
									<li>Atendre les vostres sol·licituds d&#39;informació pública.</li>
									<li>Gestionar els procediments de contractació administrativa i complir les obligacions derivades dels contractes que hagueu celebrat amb nosaltres.</li>
									<li>Exercir les competències del SMC segons la normativa vigent .</li>
								</ul>
							</li>
						</ul>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioRecollida}>4. Com recollim les vostres dades personals i quines són?</h4>
						<ul>
							<li>
								<strong>Informació que ens faciliteu mitjançant formularis web</strong>
								<p>Alguns dels formularis web a través dels quals recollim les vostres dades personals són:</p>
								<ul>
									<li>Bústies de contacte.</li>
									<li>Inscripció a esdeveniments organitzats per el SMC.</li>
									<li>Sol·licitud d&#39;informació pública (transparència).</li>
									<li>Registre d&#39;usuaris, per a la descàrrega d&#39;informació i/o l&#39;ús de certs serveis.</li>
								</ul>
								<p>En aquests casos, en el moment de la recollida s&#39;indica la informació bàsica sobre protecció de dades, especialment la seva finalitat.</p>
								<p>En general, les dades personals que ens faciliteu mitjançant aquests formularis són:</p>
								<ul>
									<li>Adreça de correu electrònic.</li>
									<li>Nom i cognoms.</li>
									<li>Adreça postal.</li>
									<li>Nom d&#39;usuari i contrasenya per accedir a les nostres aplicacions web i serveis.</li>
									<li>Nom d&#39;empresa.</li>
								</ul>
							</li>

							<li>
								<strong>Informació que ens faciliteu mitjançant correu electrònic, telèfon, xarxes socials i altres canals de comunicació</strong>
								<p>
									En aquests casos, la informació que recollim és la que ens proporcioneu de forma proactiva i voluntària, i només la utilitzem per gestionar les vostres consultes, peticions, suggeriments, queixes, etc. Part d&#39;aquestes dades poden residir en servidors de
									terceres parts (Twitter, Facebook, etc.).
								</p>
							</li>

							<li>
								<strong>Informació que recollim de les vostres visites als nostres webs</strong>
								<p>Pel simple fet de navegar pels nostres webs, recollim informació limitada dels usuaris i estadístiques globals anònimes.</p>
								<p>Aquesta informació la utilitzem per millorar l&#39;accés als continguts i als serveis que us oferim, i per monitoritzar el seu rendiment.</p>
								<p>
									Aquesta informació l&#39;obtenim mitjançant les galetes que es desen en els vostres navegadors i els <em>logs</em> que es desen en els nostres servidors web.
								</p>
							</li>
							<li>
								<strong>Informació que recollim quan us autentiqueu</strong>
								<p>
									Alguns dels nostres serveis i aplicacions web permeten un ús personalitzat. A aquest efecte, és necessari que us identifiqueu amb un usuari i una contrasenya, dades que es poden desar en format de galeta en el vostre navegador per tal que pugueu gaudir
									d&#39;aquesta personalització i/o per tal que no hagueu d&#39;autenticar-vos en cada accés.
								</p>
							</li>

							<li>
								<strong>Dades de menors</strong>
								<p>Si bé els continguts dels nostres webs i aplicacions poden ser utilitzats per menors d&#39;edat, en cap cas requerim les seves dades personals.</p>
								<p>Si sou menors d&#39;edat, si us plau no intenteu registrar-vos com a usuari dels nostres webs o aplicacions. Si descobrim que hem obtingut informació personal d&#39;un menor, eliminarem aquesta informació al més aviat possible.</p>
							</li>
						</ul>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioConservacio}>5. Durant quant de temps conservarem les vostres dades?</h4>
						<p>Només emmagatzemem la vostra informació personal en la mesura que la necessitem, a fi de poder utilitzar-la segons la finalitat per a la qual va ser recollida, i segons la base jurídica del seu tractament, de conformitat amb la llei aplicable.</p>
						<p>
							Conservarem la vostra informació personal mentre estigueu registrats com a usuaris dels nostres serveis, mentre existeixi una relació contractual i/o comercial, o mentre no exerciu el vostre dret de supressió, cancel·lació i/o limitació del tractament de les vostres dades
							(per a més informació, vegeu l&#39;apartat sobre els vostres drets). En aquests casos, conservarem la informació degudament bloquejada, sense fer-ne cap ús, mentre pugui ser necessària per a l&#39;exercici o la defensa de reclamacions o pugui derivar-se algun tipus de
							responsabilitat judicial, legal o contractual del tractament de les vostres dades, que hagi de ser atesa i per a la qual sigui necessari recuperar-la.
						</p>

						<p>També podem conservar les vostres dades personals durant un temps addicional raonable per facilitar la resposta a consultes, sol·licituds o queixes que pugueu adreçar-nos posteriorment.</p>

						<p>Per determinar els períodes de conservació de dades personals, tenim en compte:</p>
						<ul>
							<li>la quantitat de dades,</li>
							<li>la naturalesa de les dades,</li>
							<li>la sensibilitat de les dades,</li>
							<li>el risc potencial de danys per un ús no autoritzat o per revelació de les vostres dades,</li>
							<li>les finalitats per a les quals tractem les vostres dades i si podem aconseguir aquestes finalitats mitjançant altres mecanismes, i</li>
							<li>els requisits legals aplicables.</li>
						</ul>
						<p>En algunes ocasions, fem anònimes les vostres dades personals (per tal que no es puguin associar amb vosaltres) per a finalitats estadístiques. En aquests casos, emmagatzemem aquesta informació (anònima) de forma indefinida, sense notificar-vos-ho.</p>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioComunicacio}>6. A qui podem comunicar les vostres dades?</h4>
						<p>
							La major part de les dades que recollim resideixen en servidors nostres, però en alguns casos és necessari comunicar a terceres parts la informació que ens heu proporcionat, per poder prestar-vos el servei sol·licitat; per exemple, el lliurament de productes que adquiriu
							a través de la botiga electrònica.
						</p>
						<p>
							També hi ha empreses que ens presten altres tipus de serveis, per exemple, de l&#39;entorn de les tecnologies de la informació. Aquestes terceres parts només tenen accés a la informació personal que necessiten per dur a terme els seus serveis. Se&#39;ls exigeix que
							mantinguin la confidencialitat respecte de les vostres dades i no poden utilitzar-les de cap altra forma que no sigui la que hem sol·licitat.
						</p>

						<p>En tots els casos, assumim la responsabilitat per la informació personal que ens faciliteu i sol·licitem a aquelles empreses amb què compartim les vostres dades que apliquin el mateix grau de protecció que nosaltres.</p>

						<p>Així mateix, la vostra informació personal estarà a disposició de les administracions públiques, jutges i tribunals, per a l&#39;atenció de les possibles responsabilitats sorgides del tractament.</p>

						<p>Les dades no es comunicaran a altres categories de destinataris, excepte en els casos previstos per la llei o quan ho hagueu consentit prèviament.</p>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioProteccio}>7. Com protegim les vostres dades?</h4>
						<p>Sempre que estiguin sota el nostre control, farem tot el possible per assegurar que les vostres dades personals es tractin d&#39;una forma que garanteixi la seguretat necessària per evitar-ne un ús no autoritzat o il·legal, la seva pèrdua accidental, destrucció o dany.</p>

						<p>
							Amb aquesta finalitat, utilitzem mesures tècniques i organitzatives adequades que, alhora, són revisades periòdicament. Protegim la vostra informació personal mitjançant l&#39;ús d&#39;una combinació de controls de seguretat tant físics com informàtics o lògics, fins i
							tot controls d&#39;accés que restringeixen i administren la forma com les vostres dades personals són tractades, administrades i gestionades. També ens assegurem que els nostres treballadors estiguin degudament capacitats per protegir la vostra informació personal.
						</p>

						<p>Hem establert procediments per gestionar qualsevol incidència sospitosa relacionada amb dades personals que pogués esdevenir-se, la qual us seria notificada, així com qualsevol regulació aplicable a la incidència que legalment estiguem obligats a complir.</p>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioDrets}>8. Quins són els vostres drets de protecció de dades i com es poden exercir</h4>
						<ul>
							<li>Retirada del consentiment: Quan estiguem utilitzant la vostra informació personal a partir del vostre consentiment, teniu el dret de retirar-lo en qualsevol moment.</li>
							<li>
								Dret a ser informat: Teniu el dret a ser informats sobre l&#39;ús de la vostra informació personal. Aquesta política, i els textos legals resumits que utilitzem en les nostres comunicacions i formularis, pretenen ser una descripció clara i transparent al respecte.
							</li>
							<li>Dret d&#39;accés: Podeu sol·licitar-nos (per escrit) quina informació vostra tenim i/o demanar-nos-en una còpia.</li>
							<li>
								Dret d&#39;eliminació: A partir del 25 de maig de 2018, podeu exercir el vostre “dret a l&#39;oblit”, és a dir, d&#39;eliminar les dades que us puguin identificar personalment. Hi pot haver ocasions en què no puguem complir aquesta sol·licitud per motius legals, fet
								que us seria notificat. En alguns casos, suggerirem donar-vos de baixa de futures comunicacions, en lloc d&#39;eliminar les dades.
							</li>
							<li>Dret de rectificació: Si les vostres dades són incorrectes en les nostres bases de dades, teniu el dret de demanar-nos la seva actualització.</li>
							<li>
								Dret a la limitació del tractament: En certes situacions, teniu el dret de demanar-nos una limitació en el tractament que fem de les vostres dades, si no esteu d&#39;acord amb la seva exactitud o ús legítim. Això comporta el marcat de les dades personals conservades,
								amb la finalitat de limitar el seu futur tractament.
							</li>
							<li>
								Dret a la portabilitat de les dades: Quan estiguem utilitzant la vostra informació personal amb el vostre consentiment, la llei us permet demanar-nos la portabilitat de les vostres dades a un altre proveïdor de serveis. En aquest cas, us facilitarem (a vosaltres o a
								la tercera part que ens hagueu indicat) les vostres dades personals en un format estructurat, d&#39;ús comú i llegible, sempre que sigui tècnicament viable.
							</li>
							<li>
								Dret d&#39;oposició i decisions individuals automatitzades: Podeu, sempre que no concorri cap de les excepcions previstes en el Reglament, oposar-vos a que les vostres dades siguin objecte de tractament. Aquesta oposició, la podeu presentar en qualsevol moment, i es
								podrà basar en motius relacionats amb la vostra situació particular. En aquest cas, deixarem de tractar les vostres dades personals.
							</li>
						</ul>
						<p>Alguns d&#39;aquests drets els podeu exercir directament a través dels formularis web habilitats a aquest efecte i també mitjançant l&#39;enllaç corresponent en els correus informatius que us enviem (si és el cas).</p>

						<p>
							Complementàriament, podeu sol·licitar l&#39;exercici de qualsevol d&#39;aquests drets adreçant un correu electrònic a 
							<a href='mailto:protecciodades.meteocat@gencat.cat'>protecciodades.meteocat@gencat.cat</a>.
						</p>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioCookies}>
							9.- Galetes (<em>cookies</em>)
						</h4>
						<p>
							Utilitzem galetes (<em>cookies</em>) per distingir-vos d&#39;altres usuaris en els nostres webs, per millorar la informació i els serveis que us oferim, i per facilitar-vos l&#39;accés. Aquestes galetes no poden ser utilitzades per identificar-vos personalment, ja que
							s&#39;associen únicament a un usuari anònim i el seu dispositiu.
						</p>

						<p>
							Podeu configurar el vostre navegador per rebutjar totes o algunes galetes, o per tal que us alerti quan els webs n&#39;instal·len o hi accedeixen. Si desactiveu o rebutgeu les galetes, tingueu en compte que algunes parts dels webs poden ser inaccessibles o no funcionar
							correctament.
						</p>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioCanvis}>10.- Canvis en aquesta política</h4>
						<p>
							Qualsevol canvi que en el futur puguem fer a la nostra política de privacitat es publicarà en aquesta pàgina i, si escau, us ho notificarem per correu electrònic. En cas que sigui necessari, us sol·licitarem que, per continuar utilitzant els nostres serveis, llegiu i
							accepteu els nous termes.
						</p>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioContacte}>11.- Contacte</h4>
						<p>
							Si teniu qualsevol tipus de consulta o comentari, o si desitgeu fer-nos algun suggeriment sobre com utilitzem les dades personals, podeu enviar un correu electrònic a <a href='mailto:protecciodades.meteocat@gencat.cat'>protecciodades.meteocat@gencat.cat</a>.
						</p>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioReclamacions}>12.- Reclamacions</h4>
						<p>
							Teniu dret a presentar una reclamació al Delegat de Protecció de Dades de l&#39;ICGC, a través de l&#39;adreça 
							<a href='mailto:dpd.meteocat@gencat.cat'>dpd.meteocat@gencat.cat</a>.
						</p>
						<p>Si, un cop fet això, no veieu resolta la reclamació, podeu interposar-la davant l&#39;Autoritat Catalana de Protecció de Dades mitjançant la seva seu electrònica.</p>
						{botoPujarTaulaContinguts}

						<h4 id={clauSecccioRecomanacions}>13.- Recomanacions</h4>
						<ul>
							<li>No faciliteu a ningú ni el vostre usuari ni la vostra contrasenya.</li>
							<li>No apunteu el vostre usuari ni la vostra contrasenya en llocs de fàcil accés, com l&#39;ordinador o l&#39;agenda.</li>
							<li>Desconnecteu sempre la sessió del navegador després d&#39;haver accedit a una zona de seguretat o d&#39;haver introduït al sistema el vostre usuari o la vostra contrasenya.</li>
						</ul>
						{botoPujarTaulaContinguts}
					</div>
				</Modal>
			</div>
		);
	}
}

export default AvisLegal;



// WEBPACK FOOTER //
// ./src/components/peu/avisLegal.js